import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import Lozenge from '@atlaskit/lozenge';
import Modal from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import TableTree from '@atlaskit/table-tree';

// @source
import { crypto } from '../../../../../utils';
import { Report, User } from '../../../../../server';
import ErrorModal from '../ErrorModal';
import PermissionButton from './PermissionButton';
import * as Styled from '../../styled';

const initialState = {
  message: false,
  permissions: [],
};

class ReportPermissions extends Component {
  constructor(props) {
    super(props);
    this.isLoading = 2;
    this.state = initialState;
    this.unmount = false;
    this.uuid = crypto.decode(this.props.uuid);
    this.isUserAllowed = this.isUserAllowed.bind(this);
  }

  componentWillMount() {
    if (!this.props.users.override) {
      User.fetch({
        dispatch: this.props.dispatch,
        success: () => {
          this.isLoading -= 1;
        },
      });
    } else {
      this.isLoading -= 1;
    }

    Report.users({
      data: {
        report: this.uuid,
      },
      success: (permissions) => {
        this.isLoading -= 1;
        this.setStateUnmount({ permissions });
      },
    });
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  isUserAllowed(username) {
    return Boolean(this.state.permissions.includes(username));
  }

  renderTableTree() {
    return (
      <Styled.TableTreeScope>
        <TableTree
          columns={[
            props => props.Username,
            props => (
              <PermissionButton
                key={props.Username}
                report={this.uuid}
                username={props.Username}
                permission={this.isUserAllowed}
              />
            ),
          ]}
          columnWidths={[1000, 175]}
          items={this.props.users.data.map(elem => ({ content: elem }))}
        />
      </Styled.TableTreeScope>
    );
  }

  render() {
    if (this.props.reports.override) {
      this.report = this.props.reports.data.find(item => item.Name === this.uuid);
      if (!this.report) {
        return <ErrorModal onClose={this.props.onClose} />;
      }
    }

    return (
      <Modal
        heading="Change permissions"
        onClose={this.props.onClose}
        width="medium"
        actions={[{
          appearance: 'subtle',
          onClick: this.props.onClose,
          text: 'Close',
        }]}
      >
        {!this.props.reports.override || this.isLoading
          ? (
            <div style={{ padding: '35px 0', textAlign: 'center' }}>
              <Spinner size="medium" />
            </div>
          )
          : (
            <div>
              <p>
                Set the permissions for the report
                <Lozenge>{this.report.Name}</Lozenge>
              </p>
              {this.renderTableTree()}
            </div>
          )}
        {this.state.message}
      </Modal>
    );
  }
}

ReportPermissions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  reports: PropTypes.shape().isRequired,
  users: PropTypes.shape().isRequired,
  uuid: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  reports: state.Report,
  users: state.User,
});

export default connect(mapStateToProps)(ReportPermissions);
